// extracted by mini-css-extract-plugin
module.exports = {"arrowBtn":"Arrow_arrowBtn__3lE-7","arrowImg":"Arrow_arrowImg__2WIE7"};